import { Guid, Nillable } from '@web/utils';
import { AdminBannerStatus } from '../enums/admin-banner-status';
import { Multimedia } from '@web/shared/module/multimedia';
import { BannerLocationType } from '../../shared/enums/banner-location-type';

export class AdminBannerDetails {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      file: Multimedia;
      id: Guid;
      location: BannerLocationType;
      smallFile?: Nillable<Multimedia>;
      redirects: number;
      status: AdminBannerStatus;
      url?: Nillable<string>;
      visibilityEndDate?: Nillable<Date>;
      visibilityStartDate?: Nillable<Date>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }
  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get location(): BannerLocationType {
    return this.data.location;
  }

  public get file(): Multimedia {
    return this.data.file;
  }

  public get smallFile(): Nillable<Multimedia> {
    return this.data.smallFile;
  }

  public get status(): AdminBannerStatus {
    return this.data.status;
  }

  public get visibilityStartDate(): Nillable<Date> {
    return this.data.visibilityStartDate;
  }

  public get visibilityEndDate(): Nillable<Date> {
    return this.data.visibilityEndDate;
  }

  public get redirects(): number {
    return this.data.redirects;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }
}
